var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMezo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 24,
    viewBox: "0 0 174 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3552_8693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8301 13.4623C98.6357 11.1763 97.9559 9.54269 97.0522 7.25672H96.9242C97.1188 9.70713 97.2148 11.3407 97.2148 13.7884V23.423H93.0159V0.560547H97.7L102.094 9.24886C103.288 11.5995 104 13.1361 104.967 15.4221C105.938 13.1361 106.647 11.5995 107.841 9.24886L112.235 0.560547H116.919V23.4256H112.72V13.7911C112.72 11.3407 112.816 9.70713 113.011 7.25941H112.883C111.979 9.54538 111.299 11.179 110.105 13.465L104.967 23.4283L99.8301 13.465V13.4623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.364 18.5248C136.428 21.4631 133.682 23.9135 129.321 23.9135C123.96 23.9135 120.598 19.9939 120.598 14.9314C120.598 9.8688 124.053 5.94922 129.222 5.94922C133.485 5.94922 136.071 8.23519 137.138 11.6318C137.524 12.8718 137.687 14.3113 137.687 15.7482V16.4005H124.765C124.893 18.5248 126.412 20.8107 129.318 20.8107C131.515 20.8107 132.645 19.5707 133.032 18.5248H137.362H137.364ZM124.767 13.2978H133.523C133.427 11.0118 131.907 9.05199 129.225 9.05199C126.543 9.05199 125.026 11.0118 124.767 13.2978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.424 20.158V23.4252H139.564V20.158L148.964 9.70667H139.886V6.43945H154.099V9.70667L144.698 20.158H154.421H154.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.213 23.9135C159.884 23.9135 156.426 19.9939 156.426 14.9314C156.426 9.8688 159.884 5.94922 165.213 5.94922C170.542 5.94922 174 9.8688 174 14.9314C174 19.9939 170.545 23.9135 165.213 23.9135ZM165.213 20.649C168.604 20.649 169.993 17.7106 169.993 14.9341C169.993 12.1575 168.604 9.21913 165.213 9.21913C161.822 9.21913 160.433 12.1602 160.433 14.9341C160.433 17.708 161.822 20.649 165.213 20.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2454 20.509L28.6432 12.0175V11.9798L37.001 20.4713C39.4164 22.9136 42.3703 24 45.2842 24C51.3813 24 57.2464 19.1935 57.2464 11.9798L65.6042 20.4713C68.0196 22.9136 70.9735 24 73.8874 24C79.9845 24 85.8496 19.1935 85.8496 11.9798H78.6782L70.3203 3.5287C67.905 1.08638 64.9138 0 61.9998 0C55.9028 0 50.075 4.76873 50.075 11.9798L41.7171 3.5287C39.3018 1.08638 36.3105 0 33.3966 0C27.2996 0 21.4717 4.76873 21.4717 11.9798L0 12.0175C0 19.269 5.94245 23.9596 12.0395 23.9596C14.9534 23.9596 17.9073 22.8732 20.2454 20.509Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3552_8693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMezo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mezo.bca85e9de8bad0f5c1c8af6c7ac60fa6.svg";